/**
 * Virtual fitness center ID for B2C direct users.
 * Created in the fitness backend Firestore as a standalone center.
 */
export const VIDA_FITNESS_CENTER_ID = 'gundo-vida-direct';

export const API_BASE_URL =
  import.meta.env.VITE_FITNESS_API_URL ??
  (import.meta.env.PROD
    ? 'https://gundo-admin-fitness-api-7awxzj56ha-uc.a.run.app/api'
    : 'http://localhost:3001/api');

export const APP_NAME = 'Gundo Vida';
export const APP_TAGLINE = 'Tu bienestar, personalizado';
export const APP_URL = 'https://mi.gundo.life';

/** Engine Marketing Hub API for subscriber registration + emails */
export const ENGINE_API_URL =
  import.meta.env.VITE_ENGINE_API_URL ??
  'https://gundo-engine-xlpp333cua-uc.a.run.app';

/** Free tier limits */
export const FREE_PLAN_DAYS = 2;
export const FREE_SCANS_PER_MONTH = 5;

/** Pro tier — pricing */
export const PRO_PLAN_DAYS = 14;
export const PRO_PRICE_MONTHLY = 5;
/** €5/mo × 12 × 0.8 = €48/yr (20% off, ~€4/mo equivalent, save €12/year). */
export const PRO_PRICE_ANNUAL = 48;
export const PRO_ANNUAL_DISCOUNT_PERCENT = 20;
/** Days of free trial offered with both monthly and annual plans. */
export const PRO_TRIAL_DAYS = 7;

/** Onboarding steps */
export const ONBOARDING_TOTAL_STEPS = 3;

/** Genie API (blood/urine tests, appointments, nutrigenetics, microbiota) */
export const GENIE_API_URL =
  import.meta.env.VITE_GENIE_API_URL ??
  'https://genie-api-738128600397.europe-west1.run.app';

/**
 * Nutritional Engine API — canonical food scanner (Bedrock Sonnet) shared with
 * ultrapersonalización. Replaces the legacy fitness-api scanner (2026-06-12);
 * the rest of Vida keeps talking to fitness-api via API_BASE_URL.
 */
export const NUTRITIONAL_ENGINE_API_URL =
  import.meta.env.VITE_NUTRITIONAL_ENGINE_API_URL ??
  'https://nutritional-engine-api-7awxzj56ha-uc.a.run.app/api';

/**
 * Public WhatsApp number for direct chat with Gundo (FAB / wa.me link).
 * E.164 without the + (wa.me format requirement).
 */
export const WHATSAPP_GUNDO_NUMBER = '573001220042';
